exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".panelContent__2MjQ {\n  margin-top: 10px; }\n  .panelContent__2MjQ .inputField__3k5T {\n    display: inline-block;\n    margin: 0 8px; }\n", "", {"version":3,"sources":["/app/src/ui/components/src/ui/components/emb-auto-dismiss.scss"],"names":[],"mappings":"AAAA;EACE,iBAAiB,EAMlB;EAPD;IAII,sBAAsB;IACtB,cAAc,EACf","file":"emb-auto-dismiss.scss","sourcesContent":[".panelContent {\n  margin-top: 10px;\n\n  .inputField {\n    display: inline-block;\n    margin: 0 8px;\n  }\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"panelContent": "panelContent__2MjQ",
	"inputField": "inputField__3k5T"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true,"modules":true,"importLoaders":1,"localIdentName":"[local]__[hash:base64:4]"}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/ui/components/emb-auto-dismiss.scss
// module id = 1083
// module chunks = 0